import _ from 'underscore';

import { Set } from '~commonInfra/utils/Set';

import { INamedItemInfo } from '../../../spacesPlatform/models/resourceInfoParts';
import { IRemoteRefreshAgent } from '../../serverApi/requests/remoteExtractRefresh/GetRemoteRefreshAgentsRequest';
import { IRemoteRefreshAgentInfo } from '../IRemoteRefreshAgentInfo';

export module RemoteRefreshAgentMapper {

  export function mapToResource(agents: IRemoteRefreshAgent[]): IRemoteRefreshAgentInfo[] {
    return _.map(agents, (agent: IRemoteRefreshAgent): IRemoteRefreshAgentInfo => {
      const content = new Set<INamedItemInfo>((item: INamedItemInfo) => item.id);
      content.addItems(agent.content);

      return {
        id: agent.id,
        name: agent.name,
        ownerId: agent.ownerId,
        content: content
      };
    });
  }

}
